import { temAcesso } from '@/shared/auth/temAcesso'

// const Entregas = () => import('./Entregas.vue')
const Entrega = () => import('./Entrega.vue')

export default {
    path: 'entregas',
    name: 'Apoios_Entregas',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: ':entregaId',
            name: 'Apoios_Entregas_Detalhar',
            component: Entrega,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CRED-APOIO-ENTR-00')) {
                    next()
                }
            }
        }
    ]
}
